import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

import instructorClosingConversionModule from "./instructorClosingConversion/index";
import instructorFirstVisitConversionsModule from "./instructorFirstVisitConversions/index";
import instructorUtilizationModule from "./instructorUtilization/index";

const pageConfig = {
  pageName: "Instructor Performance",
  configuratorWidth: { dark: 400, light: 350 },
  moduleList: [
    instructorFirstVisitConversionsModule,
    instructorClosingConversionModule,
    instructorUtilizationModule
  ]
};

const InstructorPerformancePage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default InstructorPerformancePage;
